export default __webpack_public_path__ + "static/intern-dhruv-patel-8a80cfc81b4c96e130063722bdce2ed6.webp";